export default "/front/images/lost.svg?c88ea20fd03db5e75e4a16a6604bab0b";